import type { ServiceResponse } from "./api.types";
import { privateAPI } from "./axios";
import type { IntakeDetails } from "./intakes";

interface SendTransferResponse {
  id: string;
  patient: {
    fullName: string;
  };
  primaryInsurance: {
    name: string | null;
  };
  agentName: string;
  createdAt: string;
  dmeProvider: string | null;
}

interface Payor {
  id: string;
  label: string;
}

export const sendTransferToCompliantRX = async (
  transferId: string,
  payorId: string,
) => {
  const { data } = await privateAPI.post<ServiceResponse<SendTransferResponse>>(
    `/transfers/${transferId}/send-to-compliant-rx`,
    { payorId },
  );

  return data.data;
};

export const getPayors = async (transferId: string) => {
  const { data } = await privateAPI.get<ServiceResponse<Payor[]>>(
    `/transfers/${transferId}/payors`,
  );

  return data.data;
};

export const getTransferDetails = async (transferId: string) => {
  const { data } = await privateAPI.get<ServiceResponse<IntakeDetails>>(
    `/transfers/${transferId}`,
  );

  return data.data;
};
